import { httpStatuses } from '@reveni-io/reveni-ui'

export const getIsReturnableReason = error => {
  const response = error?.response

  if (response?.status === httpStatuses.unprocessableEntity) return response.data?.code

  return response?.data?.is_returnable_reason
}

export const getCheckOrderPayload = ({
  orderNumber,
  returnPortalId,
  identifier,
  termsAndConditions,
  type,
  isGiftReturn,
  giftRecipient,
  optsOutOfEvaluation,
}) => {
  const payload = {
    order_number: orderNumber,
    portal_id: returnPortalId,
    accepts_terms_and_conditions: termsAndConditions,
    transaction_type: type,
    is_gift_return: isGiftReturn,
  }

  if (identifier) {
    payload.identifier = identifier
  }

  if (isGiftReturn && giftRecipient) {
    payload.gift_recipient = giftRecipient
  }

  if (optsOutOfEvaluation) {
    payload.opts_out_of_evaluation = true
  }

  return payload
}
